<template>
    <div class="entranceVehicle">
        <div class="clearfix fixed">
            <van-nav-bar
                class="restclass"
                title="入场检查"
                left-text="返回"
                left-arrow
                @click-left="getBack">
                <van-cell v-if="$_has('entrance:entrance:add')" slot="right" style="background:none">
                    <van-button round size="large" style="padding:10px; font-size:0.35rem;" @click="add">创&nbsp;建</van-button>
                </van-cell>
            </van-nav-bar>
            <!-- <row>
                <van-col span="2">
                    <Icon name="arrow-left" size="26" @click="getBack" />
                </van-col>
                <van-col span="18" align="center" justify="center" style="font-size:19px;">入场车辆</van-col>
                <van-col span="3" align="center">
                    <van-button plain type="primary" size="large"
                        style="font-size:15px;" @click="add">创&nbsp;建</van-button>
                </van-col>
            </row> -->
        </div>
        <div class="clientList fixedselect">
            <row class="search">
                <van-col span="18"><search v-model="value" placeholder="请输入搜索关键词" class="search" /></van-col>
                <van-col span="2">
                    <van-button type="primary" size="normal" round style="font-size:13px;margin-top:15px;"
                        @click="queryreocrdbycondition">查&nbsp;询</van-button>
                </van-col>
                <van-col span="2" style="float:right; margin:12px 0px 0 15px;">
                    <van-icon name="scan" size="30" round title="扫一扫"
                        @click="scan" />
                </van-col>
            </row>
            <row>
                <van-col span="5"> <van-button type="primary" size="normal" round style="font-size:13px;margin-top:-5px;"
                    @click="queryallreocrd">全部</van-button></van-col>
                <van-col span="19">
                    <dropdown-menu active-color="#ee0a24">
                        <dropdown-item v-model="value1" :options="option1" />
                        <dropdown-item v-model="entranceStatus" :options="option2" />
                        <dropdown-item v-model="value3" :options="option3" />
                    </dropdown-menu>
                </van-col>

            </row>
        </div>
        <p style="height:140px" />
        <div class="clientList">

            <van-pull-refresh v-model="isDownLoading" @refresh="onDownRefresh">
                <List
                    v-model="isUpLoading"
                    :finished="upFinished"
                    :immediate-check="false"
                    :offset="10"
                    finished-text="已加载全部"
                    @load="onLoadList">
                    <div
                        v-for="(item,index) in list"
                        :key="index"
                        class="list clearfix">
                        <div class="clearfix">
                            <row>
                                <van-col span="1">{{ index+1 }}</van-col>
                                <van-col span="20">
                                    <p>
                                        <span class="info-span">{{ item.vehicleCode }}</span>
                                        <span class="info-span">{{ item.barCode }}</span>
                                        <span class="info-span">{{ item.driver }}</span>

                                    </p>
                                    <p style="line-height:20px;">
                                        <span v-if="item.entranceStatus==1||!item.entranceStatus" style="color:#000;dispaly:block;padding:0 10px 0 0;">{{ item.entranceStatus | getEntranceStatus }}</span>
                                        <span v-else class="info-span-red">{{ item.entranceStatus | getEntranceStatus }}</span>
                                        <span class="info-span-red">{{ item.enumVehicleStatusName }}</span>
                                        <span><icon name="clock-o" color="#1989fa" />入场：{{ item.entryTime }}</span>
                                    </p>
                                </van-col>
                                <van-col v-if="item.enumVehicleStatus==1 && $_has('entrance:entrance:assign')" span="3"><van-button type="primary" round @click="onClientDispatch(item)">派工</van-button></van-col>
                            </row>

                        </div>

                    </div>
                    <van-dialog
                        v-model="isShow"
                        style="font-size:18px;"
                        title="请选择"
                        show-cancel-button
                        @confirm="submit">
                        <van-field
                            v-model="submititem.maintenTypeName"
                            :readonly="projectreadonly"
                            :show-error="true"
                            :required="true"
                            :disabled="true"
                            name="maintenTypeName"
                            :rules="[ { required: true, message: '必填' } ]"
                            label="维修类型"
                            @click="!projectreadonly ? showmaintainItemse = true : showmaintainItemse==false" />

                    </van-dialog>
                </List>

                <van-popup
                    v-model="showmaintainItemse"
                    :style="{ height: '35%' }"
                    position="bottom">
                    <van-picker
                        item-height="1.173rem"
                        show-toolbar
                        :columns="maintenTypes"
                        @cancel="showmaintainItemse = false"
                        @confirm="maintenTypeNamese" />
                </van-popup>
            </van-pull-refresh>
            <p
                v-if="list.length === 0"
                class="noList">暂无数据</p>
        </div>
        <bottom />
    </div>
</template>

<script>
var moment = require('moment')
import { getrecordlist } from '@/api/maintain'
import { getcategory, getbrand, getOdd, getDictionarySelect } from '@/api/basics'
import { submitRecords } from '@/api/maintain'
import { Icon, List, Button, Col, Row, Search, DropdownMenu, DropdownItem, PullRefresh, Toast, Dialog } from 'vant'
import bottom from '@/components/bottom'
export default {
    name: 'EntranceVehicle',
    components: {
        bottom,
        Icon, List, [Button.name]: Button, [Col.name]: Col, Row, Search, DropdownMenu, DropdownItem, [PullRefresh.name]: PullRefresh
    },
    filters: {
        getEntranceStatus(val) {
            const obj = {
                1: '正常',
                2: '入场未派工',
                3: '结算未离场'
            }
            return val ? obj[val] : ''
        }
    },
    data() {
        return {
            isShow: false,
            isDownLoading: false, // 下拉刷新
            isUpLoading: false, // 上拉加载
            upFinished: false, // 上拉加载完毕
            projectreadonly: false,
            showmaintainItemse: false,
            totalCount: 0,
            maintenTypes: [],
            submititem:
            {
                'id': uuid(),
                'vehicleId': '',
                'vehicleCode': '',
                'barCode': '',
                'enumVehicleStatus': 1,
                'chassisNumber': '',
                'category': '',
                'brand': '',
                'modelId': '',
                'model': '',
                'customer': '',
                'customerId': '',
                'phone': '',
                'owner': '',
                'entryTime': '',
                'drivers': [],
                'driver': '',
                'driverPhone': '',
                'outStockType': '',
                'faultDescription': '',
                'entranceUrl': '',
                'processingMode': '',
                'maintenTypeName': '',
                'examinator': ''
            },
            parameter: {
                enumVehicleStatus: '1',
                category: '', // 车辆类别
                brand: '', // 车辆品牌
                searchKey: '',
                entranceStatus: '', // 报警状态
                pageIndex: 1, // 当前页
                pageSize: 10 // 每页多少条
            },
            list: [],
            value: '',
            value1: 0,
            value2: '',
            entranceStatus: '',
            value3: 'a',
            option1: [
                { text: '挖掘机', value: 0 },
                { text: '重卡', value: 1 },
                { text: '平地机', value: 2 }
            ],
            option2: [
                { text: '全部', value: '' },
                { text: '正常', value: 1 },
                { text: '入场未派工', value: 2 },
                { text: '结算未离场', value: 3 }
            ],
            option3: [
                { text: '三一重工', value: 'a' },
                { text: '徐工', value: 'b' },
                { text: '柳工', value: 'c' }
            ]
        }
    },
    created() {
        // console.log('111111111111111111')
        // queryreocrd();
        // querybrandlist()
        // querycategorylist()

        // console.log('333333333333')
    },
    mounted() {
        getDictionarySelect({ Code: 'Maintain:MaintenceType' }).then(res => {
            if (res.isSuccess) {
                console.log(res.data)
                this.maintenTypes = res.data
                this.maintenTypes.forEach(item => {
                    item.text = item.name
                })
            }
        })
        getbrand().then((res) => {
            if (res.code == 200) {
                // console.log('111111111111111111')
                var data = res.data
                this.option3 = []
                var all = {}
                all.text = '全部'
                all.value = ''
                this.option3[0] = all
                var i = 0
                for (i; i < data.length; i++) {
                    var item = {}
                    item.text = data[i].content
                    item.value = data[i].content
                    this.option3[i + 1] = item
                }
                this.value3 = ''
            }
        })
        getcategory().then((res) => {
            if (res.code == 200) {
                var data = res.data
                this.option1 = []
                var all = {}
                all.text = '全部'
                all.value = ''
                this.option1[0] = all
                var i = 0
                for (i; i < data.length; i++) {
                    var item = {}
                    item.text = data[i].content
                    item.value = data[i].content
                    this.option1[i + 1] = item
                }

                this.value1 = ''
            }
        })
        this.list = []
        this.queryrecord()
        window['scanit'] = data => {
            this.scanit(data)
        }
    },

    methods: {
    async submit() {
            if (this.submititem.maintenTypeName == '') {
                Toast('请选择维修类型')
                return false
            }
            this.submititem.examinator = this.$store.state.user.userInfo.nickName
            var date = new Date();
            var year = date.getFullYear(); //获取当前年份
            var month = date.getMonth() + 1; //获取当前月份
            var dat = date.getDate(); //获取当前日
            var hour = date.getHours(); //获取小时
            var minutes = date.getMinutes(); //获取分钟
            var second = date.getSeconds(); //获取秒
            const Time = year + '-' + month + '-' + dat + ' ' + hour + ':'+ minutes + ':'+ second;
            this.submititem.examineTime = Time
            await this.getOdd()
            submitRecords(this.submititem).then((res) => {
                console.log("res:" + JSON.stringify(res))
                if (res.isSuccess) {
                    //Notify({ type: 'success', message: '提交成功' })
                    Toast.success('提交成功')
                    // return
                    // if (value) {
                    //     if (this.$_has('maintain:workorder:view')) {
                    //         this.$router.push({
                    //             path: '/dispatchList',
                    //             query: {
                    //                 type: '入场处理',
                    //                 id: this.submititem.id
                    //             }
                    //         })
                    //     } else {
                    //         this.$router.push({
                    //             path: '/404'
                    //         })
                    //     }
                    // } else {
                    //     this.$router.push({
                    //         path: '/entrancevehicle'
                    //     })
                    // }
                } else {
                    Toast(res.message)
                    return false
                }
            })
        },
        // 确认维修类型
        maintenTypeNamese(val) {
            console.log(val, 'jrr')
            this.maintenTypes.forEach(async res => {
                if (res.id == val.id) {
                    this.submititem.maintenTypeName = res.name
                    this.submititem.maintenTypeId = res.code
                    this.showmaintainItemse = false
                    this.submititem.factor = res.factor
                    this.submititem.code = res.code
                }
            })
        },
        colorOrStatus(status) {
            const key = {
                1: '000', // 应收
                2: 'red', // 其他
                3: 'red'
            }
            return `status status-${key[status]}`
        },
        // 生成单号
    PrefixInteger(num, length) {
      return (Array(length).join('0') + num).slice(-length);
    },
    async getOdd() {
        let tenantCode = null
        if (!this.$store.state.user.userInfo.tenantId) {
            tenantCode = '0000'
        }else{
            tenantCode = this.PrefixInteger(this.$store.state.user.userInfo.tenantId,4)
        }
        var sheetNo = `PG${tenantCode}${moment().format('YYYY')}${moment().format('MM')}${moment().format('DD')}`
       const res = await getOdd(sheetNo)
                    if (res.isSuccess) {
                        this.submititem.WorkOrderSheetNo = res.data.sheetNo
                        this.submititem.workOrderSheetNo = res.data.sheetNo
                        console.log(res.data, '单号')
                    }
        },
        // 返回
        getBack() {
            this.$router.push({ path: '/' })
        },
        queryrecord(isreload = true) {
            getrecordlist(this.parameter).then((res) => {
                if (res.code == 200) {
                    this.totalCount = res.data.totalCount
                    var i = 0
                    for (i; i < res.data.pagerData.length; i++) {
                        res.data.pagerData[i].entryTime = this.parsetime(res.data.pagerData[i].entryTime)
                    }
                    if (isreload == true) {
                        this.list = res.data.pagerData
                    } else {
                        this.list = this.list.concat(res.data.pagerData)
                    }
                } else {
                    Toast(res.message)
                }
            })
                .finally(() => {
                    this.isDownLoading = false
                    this.isUpLoading = false
                })
        },
        queryreocrdbycondition() {
            this.list = []
            this.parameter.pageIndex = 1
            this.parameter.category = this.value1
            this.parameter.enumVehicleStatus = this.value2
            this.parameter.entranceStatus = this.entranceStatus
            this.parameter.brand = this.value3
            this.parameter.searchKey = this.value
            this.upFinished = false
            this.queryrecord()
        },
        queryallreocrd() {
            this.list = []
            this.parameter.pageIndex = 1
            this.parameter.category = ''
            this.parameter.enumVehicleStatus = ''
            this.parameter.brand = ''
            this.parameter.searchKey = ''
            this.parameter.barCode = ''
            this.upFinished = false
            this.value3 = ''
            this.value1 = ''
            this.entranceStatus = ''
            this.queryrecord()
        },
        
        // 新增
        add() {
            this.$router.push({
                path:'/addentranceVehicle',
                query:{
                    type:'创建'
                },
            })
        },
        // 派工单
        onClientDispatch(flag) {
            this.submititem = flag
            console.log(flag)
            this.submititem.maintenTypeName = ''
            this.isShow = !this.isShow
            // if (this.$_has('maintain:workorder:view')) {
            //     this.$router.push({
            //         path: '/dispatchList',
            //         query: {
            //             type: '入场处理',
            //             id: flag
            //         }
            //     })
            // } else {
            //     this.$router.push({
            //         path: '/404'
            //     })
            // }
        },
        onDownRefresh() {
            this.parameter.pageIndex = 1
            this.upFinished = false // 不写这句会导致你上拉到底过后在下拉刷新将不能触发下拉加载事件
            this.queryrecord() // 加载数据
        },
        onLoadList() {
            this.parameter.pageIndex++
            this.isDownLoading = false
            this.queryrecord(false) // 加载数据

            if (this.totalCount == this.list.length) {
                this.upFinished = true
            } else {
                this.upFinished = false
            }
        },
        parsetime(date1) {
            var date = new Date(date1)
            var month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
            var currentDate = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
            var hours = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
            var minutes = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
            var seconds = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
            return date.getFullYear() + '-' + month + '-' + currentDate + ' ' + hours + ':' + minutes + ':' + seconds
        },
        scan() {
            window.test.ToScan()
        },
        async scanit(val) {
            this.list = []
            this.parameter.pageIndex = 1
            this.parameter.barCode = val
            getrecordlist(this.parameter).then((res) => {
                if (res.code == 200) {
                    this.totalCount = res.data.totalCount
                    var i = 0
                    for (i; i < res.data.pagerData.length; i++) {
                        res.data.pagerData[i].entryTime = this.parsetime(res.data.pagerData[i].entryTime)
                    }
                    this.list = res.data.pagerData
                } else {
                    Toast(res.message)
                }
            })
        }

    }
}
</script>

<style lang='scss' scoped>
.entranceVehicle{
  width: 100%;
  .logout{
    margin-top: -20px;
    color: blue;
  }
  .clientList{
    margin-bottom: 100px;
    padding: 0px 40px;
    h2{
      font-size: 32px;
      font-weight: 700;
      margin-bottom: 25px;
    }
    .search{
      margin:10px 0;
      button{
        width: 100px;
        height: 50px;
        color: #ffffff;
        margin-left: 10px;
        border-radius: 10px;
      }
    }
    .list{
      padding: 20px 0;
      //border-top: 1px solid #ccc;
      border-bottom: 1px solid #ccc;
      h3{
        font-size: 38px;
        font-weight: 700;
      }
      .msg{
        padding: 20px 0;
        font-size: 18px;
        .phone{
          margin-left: 10%;
          color: #3498db;
        }
      }
      p{
        color: #999;
        font-size: 20px;
        padding: 5px 0;
      }
    }
  }

}
.info-span{
    display:inline-block;
    padding:0px 8px;
    color:#000;
    width:25%;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
}
.info-span-red{
    padding:0px 8px;
    color:#f00;
}
</style>
<style lang='scss' scoped>
.nav{
  width: 100%;
  padding: 20px 0px;
  background: #3498ff;
  color: #fff;
  .nav-title{
    width: 100%;
    font-size: 30px;
    text-align: center;
    display: block;
  }
}
.noList{
  text-align: center;
  margin-top: 50%;
  font-size: 26px;
  color: #ccc;
}
.van-dialog{
  width: 70%;
  height: 15%;
  .van-dialog__content{
    height: 65%;
    padding-top: 5%;
    text-align: center;
    .van-dialog__message{
      text-align: center;
      font-size: 26px;
    }
  }
  .van-dialog__footer--buttons{
    height: 35%;
    .van-button{
      width: 50%;
      height: 100%;
      .van-button__text{
        font-size: 26px;
      }
    }
  }
}
 .fixed{
    position: fixed;
    top:0px;
    width: 100%;
    z-index:99999;
    /* height:100px; */
  }
.fixedselect{
    position: fixed;
    top:70px;
    width: 100%;
    z-index:99998;
    background: #ffffff;
    /* height:100px; */
  }

</style>
